import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/LandingPage.vue'),
    meta: {
      title: 'Flaminjoy API'
    }
  },
  {
    path: '/docs',
    name: 'Documentation',
    component: () => import('@/views/DocsPage.vue'),
    meta: {
      title: 'Flaminjoy API - Documentation'
    }
  },
  {
    path: '/sdk',
    redirect: '/sdk/node'
  },
  {
    path: '/sdk/node',
    name: 'SDK-Node',
    component: () => import('@/views/SdkPage.vue'),
    meta: {
      title: 'Node.js SDK - Flaminjoy API'
    }
  },
  {
    path: '/sdk/php',
    name: 'SDK-PHP',
    component: () => import('@/views/SdkPhpPage.vue'),
    meta: {
      title: 'PHP SDK - Flaminjoy API'
    }
  },
  {
    path: '/sdk/python',
    name: 'SDK-Python',
    component: () => import('@/views/SdkPythonPage.vue'),
    meta: {
      title: 'Python SDK - Flaminjoy API'
    }
  },
  {
    path: '/graphql-playground',
    name: 'GraphQL-Playground',
    component: () => import('@/views/GraphQLPlaygroundPage.vue'),
    meta: {
      title: 'GraphQL Playground - Flaminjoy API'
    }
  },
  {
    path: '/graphql',
    redirect: '/graphql-manual'
  },
  {
    path: '/graphql-manual',
    name: 'GraphQL-Manual',
    component: () => import('@/views/GraphQLManualPage.vue'),
    meta: {
      title: 'GraphQL API Manual - Flaminjoy API'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Gestionare titluri dinamice
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'ProductLead API'
  next()
})

export default router

